module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-valentine-right-844ef2d15059f8480a9dfe1d87ae347a.svg";